"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unMinifyPredicateDefinition = exports.minifyPredicateDefinition = void 0;
const minifiedByPredicateDefinition = new Map([
    ['I', 'IS'],
    ['I_N', 'IS_NOT'],
    ['L_T', 'LESS_THAN'],
    ['L_T_O_E', 'LESS_THAN_OR_EQUAL'],
    ['G_T', 'GREATER_THAN'],
    ['G_T_O_E', 'GREATER_THAN_OR_EQUAL'],
    ['S_W', 'STARTS_WITH'],
    ['E_W', 'ENDS_WITH'],
    ['C', 'CONTAINS']
]);
const predicateDefinitionByMinified = new Map([
    ['IS', 'I'],
    ['IS_NOT', 'I_N'],
    ['LESS_THAN', 'L_T'],
    ['LESS_THAN_OR_EQUAL', 'L_T_O_E'],
    ['GREATER_THAN', 'G_T'],
    ['GREATER_THAN_OR_EQUAL', 'G_T_O_E'],
    ['STARTS_WITH', 'S_W'],
    ['ENDS_WITH', 'E_W'],
    ['CONTAINS', 'C']
]);
function minifyPredicateDefinition(params) {
    const predicateDefinition = params.value;
    return predicateDefinitionByMinified.get(predicateDefinition);
}
exports.minifyPredicateDefinition = minifyPredicateDefinition;
function unMinifyPredicateDefinition(params) {
    const minifiedPredicateDefinition = params.value;
    return minifiedByPredicateDefinition.get(minifiedPredicateDefinition);
}
exports.unMinifyPredicateDefinition = unMinifyPredicateDefinition;
//# sourceMappingURL=predicateDefinitionMinifier.js.map